import VueRouter from 'vue-router'
import index from '@/views/Index'
import servicios from '@/views/Servicios'
import reservar from '@/views/Reservar'
import nosotros from '@/views/Nosotros'
import blog from '@/views/Blog'
import contacto from '@/views/Contacto'
import paginablog from '@/views/PaginaBlog'
import Vue from 'vue'

Vue.use(VueRouter)
const routes = [
    {path: '/', redirect: "inicio"},    
    {path: '/inicio',  name: 'inicio', component: index},
    {path: '/servicios', name: 'servicios', component: servicios},
    {path: '/reservar', name: 'reservar', component: reservar},
    {path: '/nosotros', name: 'nosotros', component: nosotros},
    {path: '/blog', name: 'blog', component: blog},
    {path: '/contacto', name: 'contacto', component: contacto},
    {path: '/paginablog', name: 'paginablog', component: paginablog},

]


export default new VueRouter({
    
    routes
})